import React, { ReactNode } from 'react';
import { Table as MuiTable, TableContainer } from '@material-ui/core';

interface ITableProps {
  children: ReactNode;
}

export const Table = ({ children }: ITableProps) => {
  return (
    <>
      <TableContainer>
        <MuiTable>{children}</MuiTable>
      </TableContainer>
    </>
  );
};
